<p-toolbar>
  <ng-template #start>
    <app-toolbar-main-controls
      [design]="currentDesign()"
      [user]="user"
      [tubulars]="tubulars()"
      [selectedTubular]="selectedTubular"
      [shortLengthUnit]="shortLengthUnit()"
      [pipeDimensionPrecisionOverrides]="pipeDimensionPrecisionOverrides()"
      [isTubularReady]="isTubularReady()"
      [isPericalDisabled]="isPericalDisabled()"
      [isPerinixDisabled]="isPerinixDisabled()"
      [isPerivisDisabled]="isPerivisDisabled()"
      [calculatingPerivis]="calculatingPerivis()"
      [calculatingPerical]="calculatingPerical()"
      [calculatingPerinix]="calculatingPerinix()"
      [isDarkMode]="isDarkMode()"
      (tubularChange)="onTubularChanged($event)"
      (calculateStress)="onCalculateStress()"
      (calculateThermal)="onCalculateThermal()"
      (calculateApb)="onCalculateApb()"
    />
  </ng-template>

  <ng-template #end>
    <app-toolbar-actions
      [compactMode]="compactMode()"
      [panelMode]="panelMode()"
      [wizardMode]="wizardMode()"
      [wizardStepIndex]="wizardStepIndex()"
      [wizardTotalSteps]="wizardTotalSteps()"
      [wizardStepLabel]="wizardStepLabel()"
      [wizardStepLabels]="wizardStepLabels()"
      [panelColumnItems]="panelColumnItems"
      [allComponents]="components()"
      (panelToggle)="togglePanelMode()"
      (wizardToggle)="toggleWizardMode()"
      (wizardPrevStep)="navigateWizardStep('prev')"
      (wizardNextStep)="navigateWizardStep('next')"
      (wizardStepSelected)="jumpToWizardStep($event)"
      (unitsConverterOpen)="openUnitsConverter()"
      (componentSelected)="onComponentSelected($event)"
      (schematicToggled)="toggleSchematic()"
    />
  </ng-template>
</p-toolbar>
